'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GeneratorCache = {};
var disableUniqueIdDuplicateChecker = false;

var UniqueIdGenerator = function () {
  function UniqueIdGenerator(namespace) {
    _classCallCheck(this, UniqueIdGenerator);

    this.base = Date.now();
    this.guidStack = [];
    this.namespace = namespace;
    this.enableUniqueChecker = true;
  }

  UniqueIdGenerator.prototype.enableChecker = function enableChecker() {
    this.enableUniqueChecker = true;
  };

  UniqueIdGenerator.prototype.disableChecker = function disableChecker() {
    this.enableUniqueChecker = false;
  };

  UniqueIdGenerator.prototype.generate = function generate(id, prefix) {
    if (!this.enableUniqueChecker || disableUniqueIdDuplicateChecker) {
      if (id) return id;
    }
    if (id && this.guidStack.indexOf(id) < 0) {
      this.guidStack.push(id);
      return id;
    }
    return this.generate(prefix + '_' + (this.base++).toString(36).toLowerCase(), prefix);
  };

  return UniqueIdGenerator;
}();

function getGenerator(namespace) {
  if (!GeneratorCache.hasOwnProperty(namespace)) {
    GeneratorCache[namespace] = new UniqueIdGenerator(namespace);
  }
  return GeneratorCache[namespace];
}

function uniqueId(value) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';

  return getGenerator(namespace).generate(value, prefix);
}

function sid() {
  return uniqueId(null, 'serial', 'serial');
}

/**
 * 清除全部的 uuid 缓存
 * 一般是在页面销毁或者重绘 / 重构的时候调用
 */
function clearUuidCache() {
  GeneratorCache = {};
}

function enableUniqueIdChecker(namespace) {
  if (namespace && GeneratorCache[namespace]) {
    GeneratorCache[namespace].enableChecker();
  } else {
    disableUniqueIdDuplicateChecker = false;
  }
}

function disableUniqueIdChecker(namespace) {
  if (namespace && GeneratorCache[namespace]) {
    GeneratorCache[namespace].disableChecker();
  } else {
    disableUniqueIdDuplicateChecker = true;
  }
}

function getSid(obj) {
  return obj && obj.__sid__;
}

function addSid(obj, id) {
  if (!obj) return obj;
  id = id || getSid(obj) || sid();
  try {
    obj.__sid__ = id;
  } catch (e) {
    // eslint-disable-line
  }
  return obj;
}

function valueHeater(val, withSid) {
  var t = typeof val === 'undefined' ? 'undefined' : _typeof(val);
  if (!val || t === 'string' || t === 'number') {
    return val;
  }
  if (Array.isArray(val)) {
    return val.map(function (item) {
      return valueHeater(item, true);
    });
  }
  if (t === 'object') {
    var ret = {};
    for (var k in val) {
      if (val.hasOwnProperty(k)) {
        ret[k] = valueHeater(val[k]);
      }
    }
    if (withSid) {
      addSid(ret);
    }
    return ret;
  }
  if (typeof val.toString === 'function') {
    return val.toString();
  }
  return null;
}

function valueCooler(obj) {
  if (obj == null) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(function (item) {
      return valueCooler(item);
    });
  }
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
    var ret = {};
    for (var k in obj) {
      if (obj.hasOwnProperty(k) && k !== '__sid__') {
        ret[k] = valueCooler(obj[k]);
      }
    }
    return ret;
  }
  return obj;
}

function i18nTransform(obj, locale) {
  if (!obj) return obj;
  if (Array.isArray(obj)) {
    return obj.map(function (item) {
      return i18nTransform(item, locale);
    });
  }
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
    if (obj.type === 'i18n') {
      if (locale !== 'zh_CN' && locale !== 'zh_TW' && !obj[locale]) {
        locale = 'en_US';
      }
      return obj[locale];
    }
    var out = {};
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        out[key] = i18nTransform(obj[key], locale);
      }
    }
    return out;
  }
  return obj;
}

function cloneDeep(val) {
  if (!val) {
    return val;
  }

  if (Array.isArray(val)) {
    return val.map(function (item) {
      return cloneDeep(item);
    });
  }

  if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
    var ret = {};
    Object.keys(val).forEach(function (key) {
      ret[key] = cloneDeep(val[key]);
    });
    return ret;
  }

  return val;
}

function encodeData(data) {
  if (Array.isArray(data)) {
    return '[' + data.map(function (v) {
      return encodeData(v);
    }).join(',') + ']';
  }

  if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
    if (data == null) {
      return 'null';
    }
    var ret = Object.keys(data).sort().map(function (key) {
      return JSON.stringify(key) + ':' + encodeData(data[key]);
    });
    return '{' + ret.join(',') + '}';
  }

  return JSON.stringify(data);
}

function isDataEqual(data1, data2) {
  return encodeData(data1) === encodeData(data2);
}

function getHotterFromSetter(setter) {
  return setter && (setter.Hotter || setter.type && setter.type.Hotter) || []; // eslint-disable-line
}

function getTransducerFromSetter(setter) {
  return setter && (setter.transducer || setter.Transducer || setter.type && (setter.type.transducer || setter.type.Transducer)) || null; // eslint-disable-line
}

function getInitialFromSetter(setter) {
  return setter && (setter.initial || setter.Initial || setter.type && (setter.type.initial || setter.type.Initial)) || null; // eslint-disable-line
}

function combineTransducer(transducer, arr, context) {
  if (!transducer && Array.isArray(arr)) {
    var _arr = _slicedToArray(arr, 2),
        toHot = _arr[0],
        toNative = _arr[1];

    transducer = { toHot: toHot, toNative: toNative };
  }

  return {
    toHot: (transducer && transducer.toHot || function (x) {
      return x;
    }).bind(context), // eslint-disable-line
    toNative: (transducer && transducer.toNative || function (x) {
      return x;
    }).bind(context) // eslint-disable-line
  };
}

function defaultInitial(value, defaultValue) {
  return value == null ? defaultValue : value;
}

function combineInitial(context, config) {
  var configInitial = config.initial || config.initialValue;
  var setterInitial = getInitialFromSetter(config.setter);

  if (typeof configInitial !== 'function') {
    configInitial = defaultInitial;
  }

  configInitial = configInitial.bind(context);

  if (setterInitial) {
    setterInitial = setterInitial.bind(context);
    return function (value, defaultValue) {
      return setterInitial(configInitial(value, defaultValue), defaultValue);
    };
  }

  return configInitial;
}

var Transducer = function () {
  function Transducer(context, config) {
    _classCallCheck(this, Transducer);

    this.setterTransducer = combineTransducer(getTransducerFromSetter(config.setter), getHotterFromSetter(config.setter), context);

    this.configTransducer = combineTransducer(config.transducer, config.transform, context);

    this.context = context;
  }

  Transducer.prototype.toHot = function toHot(data) {
    data = this.configTransducer.toHot(data);
    return this.setterTransducer.toHot(data);
  };

  Transducer.prototype.toNative = function toNative(data) {
    data = this.setterTransducer.toNative(data);
    return this.configTransducer.toNative(data);
  };

  return Transducer;
}();

function testType(obj) {
  var t = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
  if (t === 'function' && obj.prototype && (obj.prototype.isReactComponent || obj.prototype instanceof _react.Component)) {
    return 'ReactClass';
  } else if (t === 'object' && (0, _react.isValidElement)(obj)) {
    return 'ReactElement';
  }
  return t;
}

var debugEnabled = null;

function isDebug() {
  if (debugEnabled !== null) return debugEnabled;
  debugEnabled = location.search.indexOf('__ve_debug=1') >= 0;
  return debugEnabled;
}

exports.default = {
  sid: sid,
  addSid: addSid,
  getSid: getSid,
  valueHeater: valueHeater,
  valueCooler: valueCooler,
  uniqueId: uniqueId,
  clearUuidCache: clearUuidCache,
  enableUniqueIdChecker: enableUniqueIdChecker,
  disableUniqueIdChecker: disableUniqueIdChecker,
  i18nTransform: i18nTransform,
  cloneDeep: cloneDeep,
  testType: testType,
  encodeData: encodeData,
  isDataEqual: isDataEqual,
  isDebug: isDebug,
  combineInitial: combineInitial,
  Transducer: Transducer
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-utils@1.1.0@@ali/ve-utils/build/index.js
// module id = 4
// module chunks = 0